"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ef_env_utils_1 = require("@ilc-technology/ef-env-utils");

var dom_1 = require("../utils/dom");

var Field_1 = __importDefault(require("./Field"));

var misc_1 = require("../utils/misc");

var misc_2 = require("../utils/misc");

var intl_phone_number_1 = require("../plugins/intl-phone-number");

var inputTypeMapping = {
  homePhone: 'tel',
  mobilePhone: 'tel',
  email: 'email',
  attendees: 'number'
};
var inputPatternMapping = {
  homePhone: '[0-9]*',
  mobilePhone: '[0-9]*'
};

var Text = function (_super) {
  __extends(Text, _super);

  function Text(configuration, form) {
    var _this = _super.call(this) || this;

    _this.configuration = configuration;
    _this.form = form;
    _this._inputElement = null;
    _this._previousValue = '';

    _this.render = function () {
      var _a = _this,
          form = _a.form,
          configuration = _a.configuration;
      var name = configuration.name,
          type = configuration.type,
          placeholder = configuration.placeholder,
          label = configuration.label,
          autocompleteValue = configuration.autocompleteValue,
          _b = configuration.defaultValue,
          defaultValue = _b === void 0 ? '' : _b;
      var _c = form.settings,
          applyGud = _c.applyGud,
          labelAsPlaceholder = _c.labelAsPlaceholder;
      var lap = misc_1.parseLabelAsPlaceholder(name, type, labelAsPlaceholder);
      _this._inputElement = dom_1.createElement('input', {
        id: form.settings.id + "-" + name,
        type: inputTypeMapping[name] || 'text',
        pattern: inputPatternMapping[name],
        name: name,
        placeholder: lap ? label : placeholder,
        class: 'ef-input',
        value: defaultValue,
        autocomplete: autocompleteValue
      });
      form.data[configuration.name] = defaultValue;
      var abbr = dom_1.createElement('abbr', {
        class: 'ef-form-label__required',
        title: 'required'
      }, ' *');
      var labelText = dom_1.createElement('span', {
        for: form.settings.id + "-" + configuration.name
      }, label || '');
      var labelNode = dom_1.createElement('label', {
        for: form.settings.id + "-" + configuration.name,
        class: 'form-placeholder ef-form-label'
      }, labelText, applyGud && _this.isRequired() ? abbr : '');
      var inputWrapper = dom_1.createElement('div', {
        class: 'ef-input-w'
      }, _this._inputElement);
      var errorMessageWrapper = dom_1.createElement('div', {
        class: 'ef-form-validation ef-form-error-message'
      });

      if (applyGud) {
        _this.htmlElement = dom_1.createElement('div', {
          class: "ef-form-group u-mb-m"
        }, lap ? '' : labelNode, inputWrapper, errorMessageWrapper);
      } else {
        _this.htmlElement = dom_1.createElement('div', {
          class: "ef-form-" + (applyGud ? 'group' : 'control') + " ef-form-" + configuration.name + "-wrapper\n        ef-form-" + configuration.type + "-wrapper ef-input-w u-s-mb-xs" + (defaultValue ? '' : ' ef-form-empty')
        }, _this._inputElement, labelNode, errorMessageWrapper);
      }

      _this._inputElement.addEventListener('change', function (_a) {
        var target = _a.target;
        return __awaiter(_this, void 0, void 0, function () {
          var value, validation;

          var _b;

          return __generator(this, function (_c) {
            switch (_c.label) {
              case 0:
                value = target.value;

                if (!this.htmlElement) {
                  return [2];
                }

                _super.prototype._executeListeners.call(this, 'change');

                return [4, _super.prototype.validate.call(this)];

              case 1:
                validation = _c.sent();
                form.data[configuration.name] = validation.outcome ? value : null;

                if (applyGud) {
                  (_b = this.htmlElement.querySelector('.ef-form-validation')) === null || _b === void 0 ? void 0 : _b.classList.toggle('-is-invalid', !validation.outcome);
                }

                this.htmlElement.classList.toggle('ef-form-empty', !value);
                dom_1.createErrorMessageNodes(errorMessageWrapper, validation.errorList);

                _super.prototype._executeListeners.call(this, 'validationCompleted');

                this._previousValue = value;
                return [2];
            }
          });
        });
      });

      if (configuration.type === 'datepicker') {
        var iterations_1 = 0;
        var maxIterations_1 = 30;
        var windowMoment_1 = setInterval(function () {
          if (window.moment) {
            var cultureCode = ef_env_utils_1.getMarketInfoByMarketCode(form.settings.marketCode).cultureCode;
            window.moment.locale(cultureCode);
            var picker = new window.Pikaday({
              field: document.getElementById(form.settings.id + "-" + name),
              firstDay: 1,
              format: 'LL',
              toString: function toString(date, format) {
                return window.moment(date).format(format);
              },
              minDate: new Date(),
              i18n: {
                months: window.moment.months(),
                weekdays: window.moment.weekdays(),
                weekdaysShort: window.moment.weekdaysShort()
              }
            });
            clearInterval(windowMoment_1);
          } else if (iterations_1 >= maxIterations_1) {
            console.error("[Forms X] Datepicker initialization failed. window.moment: " + window.moment);
            clearInterval(windowMoment_1);
          } else {
            iterations_1++;
          }
        }, 500);
      }

      return _this.htmlElement;
    };

    return _this;
  }

  Text.builder = function (conf, form) {
    return new Text(conf, form);
  };

  Object.defineProperty(Text.prototype, "value", {
    get: function get() {
      if (this.configuration.name === 'mobilePhone' && intl_phone_number_1.phoneInput) {
        return "+" + intl_phone_number_1.phoneInput.getSelectedCountryData().dialCode + (this._inputElement ? this._inputElement.value : '');
      }

      return this._inputElement ? this._inputElement.value : '';
    },
    set: function set(value) {
      var configuration = this.configuration;

      if (this._inputElement) {
        this._inputElement.value = value;
        this.form.data[configuration.name] = value;
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "previousValue", {
    get: function get() {
      return this._previousValue;
    },
    enumerable: false,
    configurable: true
  });

  Text.prototype.triggerChangeEvent = function () {
    if (this._inputElement) {
      misc_2.triggerEvent(this._inputElement, 'change');
    }
  };

  return Text;
}(Field_1.default);

exports.default = Text;
Field_1.default.register('text', Text.builder);
Field_1.default.register('number', Text.builder);
Field_1.default.register('datepicker', Text.builder);